import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.NoCompaniesPage.EmptyInvitations', {
    title: "It looks like you don't have any pending invitations",
    description:
        'Please ask your Administrator to invite you to an active ApprovalMax Organisation and check your emails.',
});
